import { seanceDtoSchema } from "data/seances/seances.dto.schemas";
import { z } from "zod";

export const folderDtoSchema = z.object({
  id: z.number(),
  label: z.string().nullable(),
  userId: z.number().nullable(),
  order: z.number().nullable(),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
});

export const foldersDtoSchema = z.array(folderDtoSchema);

export const folderSeanceDtoSchema = z.object({
  folderId: z.number().nullable(),
  id: z.number().nullable(),
  order: z.number().nullable(),
  userId: z.number().nullable(),
  seanceId: z.number().nullable(),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  seance: seanceDtoSchema.nullable(),
});

export const folderSeancesDtoSchema = z.array(folderSeanceDtoSchema);
